import { combineReducers } from "@reduxjs/toolkit"
import assessmentReducer from "./assessmentSlice"
import reportReducer from "./reportSlice"

const enterpriseReducer = combineReducers({
  report: reportReducer,
  assessment: assessmentReducer,
})

export default enterpriseReducer
